import styled from 'styled-components'
import { LIGHTGRAY, DARKBLUE } from '../../../styles/colors.style'
import { breakpoints } from './../../../constants/breakpoints.constants'
import { borderRadius } from '../../../styles/reusable.style'
import FontAwesome from 'react-fontawesome'

export const StyledStoreProductContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin: 40px auto;
	width: 90%;

	.main-product-container {
		display: flex;
		flex: 1;
		gap: 10px;
		flex-direction: row;
		justify-content: center;

		.gallery-container {
			aspect-ratio: 1 / 1;
			height: 500px;
			width: 500px;

			div {
				aspect-ratio: 1 / 1;
			}

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.payment-info-container {
			width: 100%;
			height: 600px;

			> div {
				text-align: right;
			}
		}

		@media screen and (max-width: ${breakpoints.MEDIUM_SCREEN}px) {
			flex-direction: column;
			align-items: center;

			.gallery-container {
				height: 400px;
				width: 400px;
			}

			.payment-info-container {
				height: -webkit-fill-available;

				> div {
					text-align: center;
				}
			}
		}

		@media screen and (max-width: ${breakpoints.MEDIUM_SCREEN - 1}px) {
			.gallery-container {
				height: 300px;
				width: 300px;
			}
		}
	}

	.description-container {
		width: 100%;
	}
`

export const StyledStartingAt = styled.p`
	.price-highlighted {
		font-weight: normal;
	}

	.price {
		font-size: 4rem;
		font-weight: bold;
		color: ${DARKBLUE};
	}
`

export const StyledPaymentMethodContainer = styled.div`
	display: flex;
	flex-direction: row;
`

export const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	.actions-container {
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		.actions-subcontainer {
			display: flex;
			flex-direction: row;
			justify-content: flex-end;

			> div:first-child {
				height: 50px;
			}

			.btn-container {
				display: flex;
				flex-direction: column;
				width: -webkit-fill-available;
				max-width: 300px;

				button {
					height: 50px;
				}
			}

			@media screen and (max-width: ${breakpoints.MEDIUM_SCREEN}px) {
				justify-content: center;

				.btn-container {
					max-width: 250px;
				}
			}
		}

		.payment-methods {
			display: flex;
			flex-direction: row;
			justify-content: flex-end;

			div {
				height: 30px;
				text-align: center;
				align-content: flex-start;
				margin: 5px;

				img {
					width: 70px;
				}
			}
		}
	}
`

export const StyledConditionsContainer = styled.div`
	display: flex;
	flex-direction: column;
`

export const StyledPaymentCondition = styled.div`
	align-items: center;
	border: 1px solid ${LIGHTGRAY};
	border-radius: ${borderRadius};
	display: flex;
	flex-direction: column;
	padding: 7px 7px 0px 7px;

	&:first-child {
		margin-bottom: 10px;
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;
		height: 80px;
		align-items: center;
	}
`

export const StyledIconContainer = styled.div`
	margin-right: 9px;
	width: 128px;
`

export const StyledIconFontAwesome = styled(FontAwesome)`
	display: flex;
	align-items: center;
	justify-content: center;
	color: #517abc;
	font-size: 30px;
	background-color: #fff;
`
